import React from 'react';
import classNames from 'classnames';

import LoadingSpinner from '../../shared/LoadingSpinner';
import Bid from './Bid';
import styles from './AvailableBids.css';

const Results = ({ activeCrew, detailEnabled, bids, loading, locationEnabled, onBidClick, ...props }) => (
  <div className="panel panel-default" {...props}>
    <div className={classNames('panel-body', styles.searchResultsContainer)}>
      {loading && <LoadingSpinner />}
      {bids.map((b) => (
        <Bid
          activeCrew={activeCrew}
          detailEnabled={detailEnabled}
          bid={b}
          key={b.id}
          locationEnabled={locationEnabled}
          onClick={() => onBidClick(b.id)}
        />
      ))}
    </div>
  </div>
);

export default Results;
